import { UserRole } from '../models/enums';

export const ADMIN_ROLES = [
  UserRole.SUPER_ADMIN,
  UserRole.APPROVER,
  UserRole.ADMINISTRATOR,
  UserRole.COMPLIANCE_OFFICER,
  UserRole.SYSTEM_OPERATOR,
] as const;

export const ROLE_PERMISSIONS = {
  [UserRole.SUPER_ADMIN]: {
    accounts: ['view', 'edit'],
    applications: ['view', 'review', 'decide'],
    deposits: ['view', 'verify', 'approve'],
    transfers: ['view', 'approve', 'execute'],
    governance: ['view', 'edit'],
    audit: ['view'],
    system: ['view'],
    // CW-13d-admin — KYC review surface. `view` lets the role see the
    // queue read-only; `act` is required for approve / reject. The list
    // page only checks `view`; per-action gating is done in the modal.
    kyc_review: ['view', 'act'],
  },
  [UserRole.APPROVER]: {
    accounts: [],
    applications: ['view', 'decide'],
    deposits: ['view', 'approve'],
    transfers: ['view', 'approve'],
    governance: [],
    audit: ['view'],
    system: [],
    kyc_review: [],
  },
  [UserRole.ADMINISTRATOR]: {
    accounts: ['view', 'edit'],
    applications: [],
    deposits: [],
    transfers: [],
    governance: ['view', 'edit'],
    audit: ['view'],
    system: [],
    kyc_review: ['view', 'act'],
  },
  [UserRole.COMPLIANCE_OFFICER]: {
    accounts: ['view'],
    applications: ['view'],
    deposits: ['view'],
    transfers: ['view'],
    governance: [],
    audit: ['view'],
    system: [],
    // Read-only access — list visible, approve/reject hidden in the modal.
    kyc_review: ['view'],
  },
  [UserRole.SYSTEM_OPERATOR]: {
    accounts: [],
    applications: [],
    deposits: [],
    transfers: [],
    governance: [],
    audit: ['view'],
    system: ['view', 'manage'],
    kyc_review: [],
  },
} as const;
